import {AUTH} from './authActionTypes';

export function postSignIn(data) {
  return {
    type: AUTH.SIGN_IN,
    payload: {
      client: 'default',
      request: {
        url: `/auth/token/`,
        method: 'post',
        data
      }
    }
  };
}

export function refreshToken(data) {
  return {
    type: AUTH.REFRESH_TOKEN,
    payload: {
      client: 'default',
      request: {
        url: `/auth/token/refresh`,
        method: 'post',
        data
      }
    }
  };
}

export function postSignUp(data) {
  return {
    type: AUTH.SIGN_IN,
    payload: {
      client: 'default',
      request: {
        url: `/auth/register/`,
        method: 'post',
        data
      }
    }
  };
}

export function postPassRecovery(data) {
  return {
    type: AUTH.PASS_RECOVERY,
    payload: {
      client: 'default',
      request: {
        url: `auth/password/forget`,
        method: 'post',
        data
      }
    }
  };
}
export function tokenRevoke() {
  return {
    type: AUTH.TOKEN_REVOKE,
    payload: {
      client: 'default',
      request: {
        url: `auth/token/revoke`,
        method: 'post'
      }
    }
  };
}
export function logOut() {
  return {
    type: AUTH.LOG_OUT,
    payload: {}
  };
}

export function postPassReset(data) {
  return {
    type: AUTH.PASS_RECOVERY,
    payload: {
      client: 'default',
      request: {
        url: `auth/password/reset`,
        method: 'post',
        data
      }
    }
  };
}

export function postSignInSocial(provider) {
  return {
    type: AUTH.GET_SIGN_URL,
    payload: {
      client: 'default',
      request: {
        url: `/auth/${provider}`,
        method: 'get'
      }
    }
  };
}

export function postSignInSocialToken(provider, token) {
  return {
    type: AUTH.SIGN_TOKEN,
    payload: {
      client: 'default',
      request: {
        url: `/auth/${provider}/callback${token}`,
        method: 'post'
      }
    }
  };
}
